import React, { useState } from "react";
import { User, Mail, Lock, Eye, EyeOff } from "lucide-react";
import "../styles/RegisterForm.css";
const RegisterForm = ({ 
  form, 
  setForm, 
  handleChange, 
  loading, 
  setIsRegister, 
  handleRegister 
}) => {
  // State lokal untuk toggle password di form register
  const [showPassword, setShowPassword] = useState(false);

  return (
    <form onSubmit={handleRegister} className="register-form-anim">
      <h1>Buat Akun</h1>
      <p className="subtitle">Bergabunglah bersama keluarga besar RSIA Annisa</p>

      {/* Input Nama */}
      <div className="input-group">
        <User className="input-icon" size={18} />
        <input
          className="auth-input"
          type="text"
          name="name"
          placeholder="Nama Lengkap"
          value={form.name}
          onChange={handleChange}
          required
        />
      </div>

      {/* Input Email */}
      <div className="input-group">
        <Mail className="input-icon" size={18} />
        <input
          className="auth-input"
          type="email"
          name="email"
          placeholder="Alamat Email"
          value={form.email}
          onChange={handleChange}
          required
        />
      </div>

      {/* Input Password */}
      <div className="input-group">
        <Lock className="input-icon" size={18} />
        <input
          className="auth-input"
          type={showPassword ? "text" : "password"}
          name="password"
          placeholder="Buat Kata Sandi"
          value={form.password}
          onChange={handleChange}
          required
        />
        <div 
          className="toggle-password" 
          onClick={() => setShowPassword(!showPassword)}
        >
          {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
        </div>
      </div>

      {/* Tombol Register */}
      <button className="btn-primary" type="submit" disabled={loading}>
        {loading ? <span className="loader"></span> : "Daftar Sekarang"}
      </button>

      {/* Switch ke Login */}
      <p className="switch-text">
        Sudah punya akun?{" "}
        <span
          className="text-link"
          onClick={() => setIsRegister(false)}
        >
          Masuk di sini
        </span>
      </p>
    </form>
  );
};

export default RegisterForm;